import { ReactNode } from 'react'
import { UserSettingsContext, UserSettingsContextType } from './UserSettingsContextTypes'

interface UserSettingsProviderProps {
  children: ReactNode
  userSettings: UserSettingsContextType
}

export function UserSettingsProvider({ children, userSettings }: UserSettingsProviderProps) {
  return (
    <UserSettingsContext.Provider value={userSettings}>
      {children}
    </UserSettingsContext.Provider>
  )
}
